angular.module('impactx.condition').controller('ConditionListController', [
    'selectedListItems',
    '$mdDialog',
    '$redirect',
    ConditionListCtrl
]);

function ConditionListCtrl(selectedListItems, $mdDialog, $redirect) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'Condition'
        },
        {
            label: "variableCosts",
            action: getVariableCosts,
            type: 'action',
            condition: canGetVarCosts,
            process: 'Condition'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/condition/templates/conditionlist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/condition/list',
        ctrl: this,
        id: "conditionlist",
        mainAction: {id: "new", link: "#/condition/0", icon: "mdi-plus"},
        excelExport: true
    };

    this.getMeta = function () {
        return this.meta;
    };

    function getDetailLink() {
        return "condition/" + selectedListItems.getFirstSelectedId();
    }

    function canGetVarCosts() {
        return selectedListItems.isSingleSelection() && impactX.isDefined(selectedListItems.getFirstSelectedItem(), "keyCode");
    }

    function getVariableCosts() {
        $mdDialog.show({
            controller: "ConditionPrepDialogCtrl",
            controllerAs: "conditionPrepDialogCtrl",
            templateUrl: "modules/condition/templates/condition-varcost-csccat.html",
            parent: angular.element(document.body),
            clickOutsideToClose: false,
            locals: {
                disId: selectedListItems.getFirstSelectedId()
            }
        })
        .then(function(answer)
        {
            $redirect.redirectTo(null, "condition/variablecosts/" + answer.cscId + "/" + answer.catId + "/" + answer.vcatId + "/" + selectedListItems.getFirstSelectedId());
        });
    };
}